
import { datadogRum } from '@datadog/browser-rum'
window.DD_RUM = datadogRum

